import { useCallback } from 'react';
import * as Sentry from '@sentry/react';

import { ERROR_RETRY, ERROR_REFRESH } from '../lib/Error';

const useError = () => {
  const sentryCaptureException = useCallback(({ message, error }) => {
    Sentry.captureException(`${message} =>${error.response.data.message}`);
  }, []);

  const onHandleStatusError = useCallback(
    ({ message, error, errorHandler }) => {
      const { status } = error.response;

      Object.keys(message).includes(status.toString())
        ? errorHandler()
        : alert(ERROR_RETRY);
    },
    [],
  );

  const onAlertStatusError = useCallback(({ message, error }) => {
    const { status } = error.response;

    onHandleStatusError({
      message,
      error,
      errorHandler: () => alert(message[status]),
    });
  }, []);

  const onHandleInvalidFieldError = ({ error, errorMsg }) => {
    const {
      status,
      data: { invalidField, message },
    } = error.response;

    errorMsg[status][invalidField] !== undefined
      ? alert(errorMsg[status][invalidField])
      : alert(`${ERROR_REFRESH}\n에러 메시지: ${message}`);
  };

  return {
    sentryCaptureException,
    onHandleStatusError,
    onAlertStatusError,
    onHandleInvalidFieldError,
  };
};

export default useError;

export const onHandleStatusError = ({ message, error, errorHandler }) => {
  const { status } = error.response;

  Object.keys(message).includes(status.toString())
    ? errorHandler()
    : alert(ERROR_RETRY);
};

export const onAlertStatusError = ({ message, error }) => {
  const { status } = error.response;

  onHandleStatusError({
    message,
    error,
    errorHandler: () => alert(message[status]),
  });
};

export const onHandleInvalidFieldError = ({ error, errorMsg }) => {
  const {
    status,
    data: { invalidField, message },
  } = error.response;

  errorMsg[status][invalidField] !== undefined
    ? alert(errorMsg[status][invalidField])
    : alert(`${ERROR_REFRESH}\n에러 메시지: ${message}`);
};
